import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdmlService {

  constructor(private readonly _httpClient: HttpClient) {}

  public exportFile(): Observable<Blob> {
    return this._httpClient.post<Blob>('/idml/export-file', null, { responseType: 'blob' as 'json' });
  }
}
